import { Calendar as CalendarIcon } from "lucide-react";
import { format, parse, isValid } from "date-fns";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { cn } from "@/lib/utils";

/**
 * Reusable date picker that emits ISO date string (YYYY-MM-DD).
 * Drop-in replacement for <Input type="date" />.
 */
export default function DatePicker({ value, onChange, placeholder = "Select date", testId, className }) {
  const date = value && isValid(parse(value, "yyyy-MM-dd", new Date())) ? parse(value, "yyyy-MM-dd", new Date()) : undefined;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          data-testid={testId}
          className={cn(
            "w-full h-11 justify-start text-left font-normal border-line bg-white hover:bg-cream rounded-md",
            !date && "text-sage",
            className
          )}
        >
          <CalendarIcon className="mr-2 h-4 w-4 text-clay" />
          {date ? format(date, "MMM d, yyyy") : placeholder}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 bg-white border-line" align="start">
        <Calendar
          mode="single"
          selected={date}
          onSelect={(d) => onChange(d ? format(d, "yyyy-MM-dd") : "")}
          captionLayout="dropdown-buttons"
          fromYear={1925}
          toYear={new Date().getFullYear()}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
